export default __webpack_public_path__ + "static/media/bg.44f42444.png";